import { render, staticRenderFns } from "./Single.vue?vue&type=template&id=a1281392&scoped=true"
import script from "./Single.vue?vue&type=script&lang=js"
export * from "./Single.vue?vue&type=script&lang=js"
import style0 from "./Single.vue?vue&type=style&index=0&id=a1281392&prod&lang=scss"
import style1 from "./Single.vue?vue&type=style&index=1&id=a1281392&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1281392",
  null
  
)

export default component.exports